import { Maybe } from '@passionware/monads';

export function createStrongCache<K, V>(
  factory: (key: K) => V,
  keyFactory: (key: K) => Maybe<string>
) {
  const map = new Map<Maybe<string>, V>();
  return {
    getOrCreate: (key: K): V => {
      const stringKey = keyFactory(key);
      const value = map.get(stringKey);
      if (!value) {
        const newValue = factory(key);
        map.set(stringKey, newValue);
        return newValue;
      }
      return value;
    }
  };
}
